module.exports = __webpack_public_path__ + "static/media/como.6df74541.png";